import { Chip } from "@material-ui/core";
import { CloseIcon } from "../../../assets";
import React, { useCallback, useMemo } from "react";

type SelectChipsProps<T> = {
  value?: Array<T>;
  onChange: (data: Array<T>) => void;
  getOptionLabel: (data: T) => string;
};

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions,react/function-component-definition
function SelectChips<T>({
  value,
  onChange,
  getOptionLabel,
}: SelectChipsProps<T>): React.ReactElement | null {
  const list = useMemo<Array<T>>(() => {
    return value && value.length ? value : [];
  }, [value]);

  const deleteItem = useCallback(
    (index: number) => () => {
      onChange(list.filter((_, itemIndex) => itemIndex !== index));
    },
    [list, onChange]
  );

  return list.length ? (
    <div className="my-2 flex-row">
      {list.map((value, index) => (
        <Chip
          key={index}
          size="medium"
          color="primary"
          className="m-1 w-max max-w-[70%] truncate rounded-lg text-left text-xs"
          label={getOptionLabel(value)}
          classes={{
            root: "bg-gray-100 text-gray-800 h-auto",
            label: "text-[10px]",
          }}
          deleteIcon={
            <CloseIcon className="min-w-[1rem] text-base text-gray-800" />
          }
          onDelete={deleteItem(index)}
        />
      ))}
    </div>
  ) : null;
}

export { SelectChips };
